import {
    faCheck,
    faEdit,
    faTimes,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IVenda } from "../../../../Interfaces/Geral/RegistraVenda/RegistraVendaInterface";
import moment from "moment";
import { formatMoneyReais } from "../../../../Tools/FormatTools";
import { Link } from "react-router-dom";
import { ACESSOS } from "../../../../Routes/Acessos";
import { Dispatch, SetStateAction } from "react";

interface IVendaDoRegistroProps {
    venda: IVenda;
    setFlag: Dispatch<SetStateAction<number>>;
    deletarVenda: (idContaProduto: number) => Promise<any>;
    ativarVenda: (idContaProduto: number, FL_STATUS: boolean) => Promise<any>;
}
export default function VendaDoRegistro(props: IVendaDoRegistroProps) {
    return (
        <div className="w-100 card card-custom p-4">
            <div>
                <h4>
                    <strong>Empreendimento: </strong>{" "}
                    {props.venda.DS_EMPREENDIMENTO}
                </h4>
                <h5>
                    <strong>Unidade: </strong>
                    {props.venda.DS_UNIDADE}
                </h5>
                <h5>
                    <strong>Status da Venda: </strong>
                    {props.venda.FL_STATUS_VENDA ? (
                        <span style={{ color: "success" }}>Ativa</span>
                    ) : (
                        <span style={{ color: "red" }}>Cancelada</span>
                    )}
                </h5>
            </div>
            <hr />
            <div className="d-flex flex-row">
                <div className="mr-8">
                    <h5>
                        <strong>Cliente: </strong>
                        {props.venda.DS_NOME}
                    </h5>
                    <h5>
                        <strong>Data da venda: </strong>
                        {moment(props.venda.DT_VENDA).format("DD/MM/YYYY")}
                    </h5>
                </div>
                <div className="mr-8">
                    <h5>
                        <strong>Valor da venda: </strong>
                        {formatMoneyReais(props.venda.VLR_UNITARIO_PRODUTO)}
                    </h5>
                    <h5>
                        <strong>Quantidade: </strong> {props.venda.QTD_PRODUTO}
                    </h5>
                </div>
                <div>
                    <h5>
                        <strong>Valor total: </strong>
                        {formatMoneyReais(props.venda.VLR_TOTAL_PRODUTO)}
                    </h5>
                </div>
            </div>

            <div className="Button-Tools">
                <button
                    className={`btn ${
                        props.venda.FL_STATUS_VENDA
                            ? "btn-outline-danger"
                            : "btn-outline-success"
                    } font-weight-bold mr-2`}
                    onClick={() => {
                        props.venda.FL_STATUS_VENDA
                            ? props
                                  .ativarVenda(
                                      props.venda.ID_CONTA_PRODUTO,
                                      false
                                  )
                                  .then(() =>
                                      props.setFlag(
                                          (value: number) => value + 1
                                      )
                                  )
                            : props
                                  .ativarVenda(
                                      props.venda.ID_CONTA_PRODUTO,
                                      true
                                  )
                                  .then(() =>
                                      props.setFlag(
                                          (value: number) => value + 1
                                      )
                                  );
                    }}
                >
                    {props.venda.FL_STATUS_VENDA ? (
                        <>
                            <FontAwesomeIcon
                                icon={faTimes}
                                size="lg"
                                className="mr-1"
                            />
                            Desativar
                        </>
                    ) : (
                        <>
                            <FontAwesomeIcon icon={faCheck} size="lg" />
                            Ativar
                        </>
                    )}
                </button>
                <Link
                    to={ACESSOS.GERAL.TELAS.REGISTRO_VENDA.EDITAR.DS_LINK(
                        props.venda.ID_CONTA_PRODUTO
                    )}
                    className="btn btn-outline-primary mb-4 mr-4"
                >
                    <FontAwesomeIcon icon={faEdit} size="lg" /> Editar
                </Link>
                <button
                    className="btn btn-outline-danger font-weight-bold mr-2"
                    onClick={() =>
                        props
                            .deletarVenda(props.venda.ID_CONTA_PRODUTO)
                            .then(() =>
                                props.setFlag((value: number) => value + 1)
                            )
                    }
                >
                    <FontAwesomeIcon icon={faTrash} size="lg" /> Excluir
                </button>
            </div>
        </div>
    );
}
